/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function (algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = '<b>' + formatPrice(price) + '</b>';
    if (comparing) {
      res +=
        ' <span class="ais-hit--price-striked"><span>' +
        formatPrice(compare_at_price) +
        '</span></span> ';
      res +=
        ' <span class="ais-hit--price-discount" style="font-weight: ' +
        Math.floor(discount_ratio * 10) * 100 +
        ';">-' +
        Math.floor(discount_ratio * 100) +
        '%</span>';
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    ifPriceVaries: function ifPriceVaries(text) {
      if (this.variants_max_price > this.variants_min_price) {
        return text;
      }
      return '';
    },
    ifNoComparePrice: function ifPriceVaries(text) {
      if (true && this.collections.includes("discountable-products")) {
        if (this.price < 200) {
          return text;
        }
      } else if (this.compare_at_price <= this.price) {
        return text;
      }
      return '';
    },
    localisationComparePrice: function localisationComparePrice() {
      return this.compare_at_price * 100;
    },
    localisationPrice: function localisationPrice() {
      return this.price * 100;
    },
    discountLocalisationPrice: function discountLocalisationPrice() {
      if (this.collections.includes("discountable-products")) {
        if (this.price > 850) {
          return this.price * 100 * 0.8;
        } else if (this.price > 400) {
          return this.price * 100 * 0.85;
        } else if (this.price > 200) {
          return this.price * 100 * 0.9;
        } else {
          return this.price * 100;
        }
      }
      return this.price * 100;
    },
    splitBrandTitle: function splitBrandTitle(text, render) {
      let escapedTitle = algolia.helpers.fullEscapedAttribute(this.title);
      var brand_array = escapedTitle.split(/ - (.*)/s);
      var brand, title;
      if (brand_array.length > 1) {
        brand = brand_array[0];
        title = brand_array[1]
      } else {
        title = escapedTitle;
        brand = this.named_tags?.brand || this.vendor;
      }
      var link = render('[[# helpers.instantsearchLink]][[/ helpers.instantsearchLink]]');
      return `<span class="visually-hidden">Vendor: </span>
          <div class="caption-with-letter-spacing light">${brand}</div>
          <h3 class="card__heading h5">
            <a href="${link}" class="full-unstyled-link">
              ${title}              
            </a>
          </h3>`;
    },
    isAvailable: function isAvailable(text, render) {
      if (this.variants_inventory_count > 0 || this.inventory_policy == "continue" || !this.inventory_management) {
        return render(text);
      } else {
        return '';
      }
    },
    isUnavailable: function isUnavailable(text, render) {
      if (this.variants_inventory_count > 0 || this.inventory_policy == "continue" || !this.inventory_management) {
        return '';
      } else {
        return render(text);
      }
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.id : '')
      );
    },
    isClearance: function isClearance(text) {
      if (this.named_tags?.clearance == "Yes") {
        return text;
      } else {
        return '';
      }
    },
    isNewIn: function isNewIn(text) {
      return ''
      if ((new Date() - new Date(this.published_at)) < (60 * 86400000)) {
        return text;
      } else {
        return '';
      }
    },
    isBestseller: function isBestseller(text) {
      if (this.named_tags.bestseller == "Yes") {
        return text;
      } else {
        return '';
      }
    },
    consolelog: function consolelog(text) {
      console.log(this);
      return '';
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        image = "//www.ropeaccessequip.com/cdn/shop/files/Coming_Soon.jpg?v=1620893634";
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function (size) {
    algolia.helpers[size + 'Image'] = (function (_size) {
      return function () {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          image = "//www.ropeaccessequip.com/cdn/shop/files/Coming_Soon.jpg?v=1620893634";
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function (res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function () {
      return function (text) {
        var render = function (value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
